export default {
    SEND_COMPOSE: () => '/email/compose',
};
